import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

const ReviewBox = (props: Props) => {
  const { children, ...rest } = props;

  return (
    <div
      className="border-grey6 bg-background2 hover:bg-background1 xs:gap-2 flex h-[128px] flex-col items-center rounded-md border px-2 pb-3 pt-4 sm:w-[164px] md:flex md:h-[72px] md:flex-row md:px-3 md:py-3 lg:w-[179px] lg:gap-3.5"
      {...rest}
    >
      {children}
    </div>
  );
};

export default ReviewBox;
